// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"a442cd81","455":"98953bc9","977":"dd315f10"}[chunkId] + ".chunk.js";
};